import supabaseClient from '@/api/supabaseClient.ts';
import { UserRepository } from '$/repositories/userRepository/UserRepository.ts';

const userRepository = new UserRepository(supabaseClient);
export default userRepository;
